import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: '100vh',
    width: '100%',
    gap: '24px',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.white,
      gap: '0px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    /* position: 'relative', */
    /* paddingBottom: '24px', */
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('laptop')]: {
      gap: '10px',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      height: 'calc(100vh - 72px)',
      /* padding: '0 16px 32px 16px', */
      gap: '32px',
    },
  };
});

export const ChatsList = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    position: 'relative',
    width: '364px',
    height: 'calc(100vh - 118px)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.white,
    borderRadius: '24px',
    padding: '24px 0 24px 0', // need to be 32px

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      height: 'calc(100vh - 72px)',
      width: '100%',
      gap: '4px',
      padding: '8px 0 0 0',
    },
  };
});

export const ChatsListMain = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
  };
});

export const ChatMessages = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    position: 'relative',
    width: 'calc(100% - 364px - 24px)', // gap = 24px, menuWidth = 270px
    minHeight: 'calc(100vh - 118px)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.white,
    borderRadius: '24px',

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      minHeight: 'calc(100vh - 72px)',
      width: '100%',
      gap: '4px',
      padding: '8px 0 0 0',
    },
  };
});

export const ChatMessagesMain = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: 'calc(100vh - 118px - 260px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    flex: '1 0 auto',
    position: 'relative',
    padding: '12px 0 32px 32px',

    [theme.breakpoints.down('tablet')]: {
      padding: '0 0 0 10px',
    },
  };
});

export const ChatMessagesMainMessageItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    gap: '8px',

    '&.left': {
      justifyContent: 'flex-end',
    },

    '&.right': {
      justifyContent: 'flex-start',
    },
  };
});

export const ChatMessagesMainMessageItemContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '50%',
    padding: '8px 10px 8px 10px',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('tablet')]: {
      width: '80%',
    },

    '> p': {
      width: '40px',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '136%',
    },

    '&.jobSeeker': {
      '&.receiver': {
        width: 'calc(50% - 40px)',
        backgroundColor: '#D9E1FF',
        borderRadius: '16px 16px 16px 2px',

        [theme.breakpoints.down('tablet')]: {
          width: '80%',
        },
        '> p': {
          color: '#666666',
        },
      },

      '&.sender': {
        backgroundColor: '#855DAC',
        borderRadius: '16px 16px 2px 16px',
        '> p': {
          color: '#fff',
        },
      },
    },

    '&.recruiter': {
      '&.sender': {
        backgroundColor: '#855DAC',
        borderRadius: '16px 16px 2px 16px',
        '> p': {
          color: '#fff',
        },
      },

      '&.receiver': {
        width: 'calc(50% - 40px)',
        backgroundColor: '#D9E1FF',
        borderRadius: '16px 16px 16px 2px',

        [theme.breakpoints.down('tablet')]: {
          width: '80%',
        },

        '> p': {
          color: '#666666',
        },
      },
    },
  };
});

export const ChatMessagesMainMessageItemContentTitle = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '150%',

    '&.jobSeeker': {
      color: '#2B163F',

      '&.sender': {
        color: '#fff',
      },
    },

    '&.recruiter': {
      color: '#fff',

      '&.receiver': {
        color: '#2B163F',
      },
    },
  };
});

export const ChatMessagesMainMessageItemContentText = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '136%',

    '&.jobSeeker': {
      color: '#444444',

      '&.sender': {
        color: '#fff',
      },
    },

    '&.recruiter': {
      color: '#fff',

      '&.receiver': {
        color: '#444444',
      },
    },
  };
});
